/* SilentoPro : mentions de piece sous chaque offre Kaching, ligne d'urgence, prix dans le bouton */
(function () {
  if (window.__silentoBundleNotes) return;
  window.__silentoBundleNotes = true;

  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.9"/><path d="M12 3v18M12 12h9" stroke="currentColor" stroke-width="1.9"/></svg>';
  var observer = null;
  var pending = false;
  var running = false;

  function config() {
    var el = document.querySelector('[data-spb-hints]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function placeUrgency() {
    var line = document.querySelector('.spb-urgency');
    if (!line || line.dataset.placed) return;
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return;
    var last = bars[bars.length - 1];
    var container = last.closest('.kaching-bundles__bars') || last.parentElement;
    if (!container) return;
    container.insertAdjacentElement('afterend', line);
    line.dataset.placed = '1';
  }

  function hints(cfg) {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    bars.forEach(function (bar, i) {
      var text = ((cfg.hints || [])[i] || '').trim();
      var anchor = bar.querySelector('.kaching-bundles__bar-subtitle') || bar.querySelector('.kaching-bundles__bar-title');
      if (!anchor) return;
      var existing = bar.querySelector('.spb-hint');
      if (!text) { if (existing) existing.remove(); return; }
      if (existing) {
        if (existing.dataset.text !== text) {
          existing.dataset.text = text;
          existing.querySelector('.spb-hint__text').textContent = text;
        }
        return;
      }
      var hint = document.createElement('span');
      hint.className = 'spb-hint';
      hint.dataset.text = text;
      hint.style.setProperty('--spb-hint-color', cfg.color || '#5E7A5B');
      hint.innerHTML = ICON + '<span class="spb-hint__text"></span>';
      hint.querySelector('.spb-hint__text').textContent = text;
      anchor.insertAdjacentElement('afterend', hint);
    });
  }

  function selectedBar() {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (sel) return sel;
    var input = document.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
    return input ? input.closest('.kaching-bundles__bar') : null;
  }

  function atc(cfg) {
    if (cfg.atc === false) return;
    var bar = selectedBar();
    if (!bar) return;
    var price = bar.querySelector('.kaching-bundles__bar-price');
    if (!price) return;
    var full = bar.querySelector('.kaching-bundles__bar-full-price');
    var priceText = price.textContent.trim();
    var fullText = full ? full.textContent.trim() : '';

    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      // la barre collante affiche deja le prix a gauche : on n'y ajoute rien
      if (btn.closest('.sticky-atc, .sticky-atc-mobile, .sticky-atc-desktop, [class*="sticky-atc"]')) {
        btn.classList.add('spb-btn', 'spb-btn--compact');
        var extra = btn.querySelector('.spb-atc');
        if (extra) extra.remove();
        return;
      }
      btn.classList.add('spb-btn');
      if (cfg.cart_icon !== false && !btn.querySelector('.spb-cart')) {
        var icon = document.createElement('span');
        icon.className = 'spb-cart';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M2.5 3h2.2l.7 3m0 0 1.9 8.4a2 2 0 0 0 2 1.6h7.2a2 2 0 0 0 2-1.5L20 6H5.4Z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="20" r="1.5" fill="currentColor"/><circle cx="17" cy="20" r="1.5" fill="currentColor"/></svg>';
        btn.insertBefore(icon, btn.firstChild);
      }
      var label = btn.querySelector('.spb-atc');
      if (!label) {
        label = document.createElement('span');
        label.className = 'spb-atc';
        label.innerHTML = '<span class="spb-atc__sep" aria-hidden="true"></span><s class="spb-atc__full"></s><span class="spb-atc__price"></span>';
        btn.appendChild(label);
      }
      if (label.dataset.state === priceText + '|' + fullText) return;
      label.dataset.state = priceText + '|' + fullText;
      var f = label.querySelector('.spb-atc__full');
      f.textContent = fullText;
      f.hidden = !fullText;
      label.querySelector('.spb-atc__price').textContent = priceText;
    });
  }

  function apply() {
    if (running) return;
    running = true;
    if (observer) observer.disconnect();
    try {
      var cfg = config();
      if (cfg) { placeUrgency(); hints(cfg); atc(cfg); }
    } catch (e) { /* on ne bloque jamais la page */ }
    if (observer) connect();
    running = false;
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; apply(); }, 120);
  }

  function host() {
    var bar = document.querySelector('.kaching-bundles__bar');
    return (bar && (bar.closest('.kaching-bundles') || bar.parentElement)) || document.body;
  }

  function connect() {
    observer.observe(host(), { childList: true, subtree: true, characterData: true });
  }

  function start() {
    apply();
    observer = new MutationObserver(schedule);
    connect();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.kaching-bundles')) schedule();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.kaching-bundles')) schedule();
    });
    document.addEventListener('shopify:section:load', schedule);
    // l'app se charge apres : on repasse quelques fois
    [400, 1200, 2500].forEach(function (d) { setTimeout(apply, d); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* SilentoPro : date du jour dans la note (evite un cache de page qui figerait la date) */
(function () {
  var el = document.querySelector('.sp-note__meta[data-sp-date]');
  if (!el) return;
  var d = new Date();
  d.setDate(d.getDate() + (parseInt(el.dataset.spDate, 10) || 0));
  try {
    el.textContent = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
  } catch (e) { /* on garde la date rendue par le theme */ }
})();
